import { v4 } from 'uuid';

import { history } from '../../../../App/history';
import { getAsync } from '../../../../utils/api';
import { actions } from '../../slice';

export default async (formId: string) => {
  const res = await getAsync("/forms/get?id=" + formId);
  if (!res.success) return;

  const uuid = v4();

  actions.createNewForm(uuid);
  actions.setFormVariable(["editingFormId", formId]);
  actions.setFormData(res.data);

  history.push("/forms/new?activeForm=" + uuid);
};
